<template>
  <div>
    <el-form
      label-width="80px"
      size="mini"
      :rules="itmesRules"
      :ref="refName"
      :model="itme"
      style="width: 300px"
    >
      <el-form-item :label="language('workShop.工序')" prop="name">
        <el-input placeholder="" v-model="itme.name"></el-input>
      </el-form-item>
      <el-form-item
        :label="language('workShop.标准工时')"
        prop="standardWorkingHours"
      >
        <el-input
          type="number"
          placeholder=""
          v-model="itme.standardWorkingHours"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="language('workShop.上限工时')"
        prop="limitWorkingHours"
      >
        <el-input
          placeholder=""
          type="number"
          v-model="itme.limitWorkingHours"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="delete_items">
      <el-link type="danger" @click="deleteItems(index)">{{
        language("workShop.移除工序")
      }}</el-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    refName: String,
    itme: Object,
    index: Number,
  },
  data() {
    return {
      itmesRules: {
        name: {
          required: true,
          message: this.language("workShop.不能为空"),
          trigger: "blur",
        },
        limitWorkingHours: {
          required: true,
          validator: this.itmesLimitWorkingHours,
          trigger: "blur",
        },
        standardWorkingHours: {
          required: true,
          validator: this.itmesStandardWorkingHours,
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    //新增时校验上限工时
    itmesLimitWorkingHours(rule, value, callback) {
      if (value === "" || value < 1) {
        callback(new Error(this.language("workShop.请输入工时大于0")));
      } 
      // else {
      //   if (
      //     this.itme.standardWorkingHours * 1 >
      //     this.itme.limitWorkingHours * 1
      //   ) {
      //     callback(
      //       new Error(this.language("workShop.上限工时不能小于标准工时"))
      //     );
      //   }
      // }
      callback();
    },
    //新增时校验标准工时
    itmesStandardWorkingHours(rule, value, callback) {
      if (value === "" || value < 0) {
        callback(new Error(this.language("workShop.请输入工时大于等于0")));
      }
      this.$refs[this.refName].validateField("limitWorkingHours");
      callback();
    },
    deleteItems(index) {
      this.$emit("deleteItems", this.index);
    },
    checkValidate() {
        
    this.$refs[this.refName].validate((valid) => {
        if (valid) {
            console.log(1)
           return false;
        } else {
            console.log(2)
          return true;
        }
      });
    },
  },
};
</script>
<style scoped>
.delete_items {
  display: flex;
  justify-content: flex-end;
}
</style>